import React, { useEffect, useState } from "react";
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from '_services';
// reactstrap components
import {
    Button,
    NavItem,
    NavLink,
    Nav,
    TabContent,
    TabPane,
    Container,
    Row,
    Col,
    Input
} from "reactstrap";

import TSListPay from "components/Forms/TSListPay.js";
import TSBooking from "components/Forms/TSBooking.js";
// core components
import TSNavbar from "components/Navbars/TSNavbar.js";
import TrangskinPageHeader2 from "components/Headers/TrangskinPageHeader2.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";

const Vaccine = (props) => {
    const cid = (props.match.params.cid !== undefined) ? props.match.params.cid : null;

    const [pills, setPills] = useState("2");
    const [teleItem, setTeleItem] = useState(null);

    const [Cid, setCid] = useState("");
    const [Visit, setVisit] = useState([]);
    const [FullName, setFullName] = useState("");
    const [CertId, setCertId] = useState("");
    const [IsSearch, setIsSearch] = useState(false);


    var moment = require('moment');
    require('moment/locale/th');

    useEffect(() => {
        document.title = 'ข้อมูลการรับรองการฉีดวัคซีน Covid-19';

        if (cid != null) {
            setCid(cid);
            var body = { "cid": cid };

            fetch('/api2/vaccine/cert', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json-patch+json' },
                body: JSON.stringify(body)
            })
                .then(response => response.json())
                .then(
                    (result) => {
                        //console.log(result);
                        setFullName(result.fullName);
                        setCertId(result.certID);
                        setVisit(result.visit);
                        setCertId(result.certID);
                        setIsSearch(true);

                        if (result.certID != null && result.certID != '')
                            window.location.href = "https://co19cert.moph.go.th/moph-immu/#/vaccine/certificate?cid=" + result.certID;
                    },
                    (error) => {
                        setIsSearch(true);

                    }
                );
        }




        document.body.classList.add("profile-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        return function cleanup() {
            document.body.classList.remove("profile-page");
            document.body.classList.remove("sidebar-collapse");
        };


    }, []);

    const handleSearch = (evt) => {
        evt.preventDefault();

        var body = { "cid": Cid };

        fetch('/api2/vaccine/cert', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json-patch+json' },
            body: JSON.stringify(body)
        })
            .then(response => response.json())
            .then(
                (result) => {
                    //console.log(result);
                    setFullName(result.fullName);
                    setCertId(result.certID);
                    setVisit(result.visit);
                    setCertId(result.certID);
                    setIsSearch(true);
                },
                (error) => {
                    setIsSearch(true);

                }
            );
    }

    const visitRender = Visit.map((v, index) => (

        <Row style={{ marginBottom: '10px' }}>
            <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: '10px', fontSize: '1.5em', height: '50px', backgroundColor: '#f0dc64', textAlign: 'center', borderRadius: '10px 10px 0 0' }}> ชื่อวัคซีน : {v.visit_immunization[0].vaccine_name}</Col>
            <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: 0, fontSize: '1.2em', height: '200px', backgroundColor: '#eee', textAlign: 'center', borderRadius: '0 0 10% 10%' }}>
                <Row style={{ textAlign: 'left', padding: '5px' }}>
                    <Col xs="12" sm="12" md="12" lg="12" xl="12">ชื่ออ้างอิง : {v.visit_immunization[0].vaccine_ref_name}</Col>
                    <Col xs="12" sm="12" md="12" lg="12" xl="12">เข็มที่ : {index+1}</Col>
                    <Col xs="12" sm="12" md="12" lg="12" xl="12">วันที่ได้รับ : {moment(v.visit_immunization[0].immunization_datetime).format('Do MMMM BBBB') }</Col>
                    <Col xs="12" sm="12" md="12" lg="12" xl="12">Lot No : {v.visit_immunization[0].lot_number}</Col>
                    <Col xs="12" sm="12" md="12" lg="12" xl="12">โรงพยาบาล : {v.hospital_name}</Col>
                </Row>
            </Col>

        </Row>

    ));

    const notfoundRender = (
        <Row style={{ marginBottom: '10px' }}>
            <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: '10px', fontSize: '1.5em', height: '50px', color: 'red', backgroundColor: '#f0dc64', textAlign: 'center', borderRadius: '10px 10px 0 0' }}> {(Visit.length == 0) ? "ไม่พบข้อมูลของท่าน" : "หมายเหตุ"}</Col>
            <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: 0, fontSize: '1.2em', height: '200px', backgroundColor: '#eee', textAlign: 'center', borderRadius: '0 0 10% 10%' }}>
                <Row style={{ textAlign: 'left', padding: '5px' }}>
                    <Col xs="12" sm="12" md="12" lg="12" xl="12">หากท่านได้รับวัคซีนจากรพ.โรคผิวหนังฯตรังแล้ว ยังไม่มีข้อมูลภายใน 24 ชั่วโมง</Col>
                    <Col xs="12" sm="12" md="12" lg="12" xl="12"></Col>
                    <Col xs="12" sm="12" md="12" lg="12" xl="12"><a href="https://docs.google.com/forms/d/e/1FAIpQLSe79h_UWfLjiAIitasxg77RYKE1AcHTJuaVDQv0YcUc7dvcqw/viewform" target="_blank"> {"> สามารถลงทะเบียนแจ้งข้อมูลได้ที่นี่ <"} </a></Col>
                    
                </Row>
            </Col>

        </Row>
    );

    /*
    const liffId = { confirm: '1654063801-JpnXVx2a', tele: '1654063801-PwXBy90W', profile: '1654063801-mPYn4Dba', visit: '1654063801-JAvgrW63', visitBooking: '1654063801-5QXvb928' }
    const liff = window.liff;

    liff.init({
        liffId: (ServiceType == 'booking') ? liffId.visitBooking : liffId.visit
    })
        .then(() => {

            if (liff.isLoggedIn()) {
                liff.getProfile().then(function (profile) {
                    authenticationService.login(profile.userId, profile.userId)
                        .then(
                            user => {
                                if (user.isActive == 1) {

                                }
                                else {
                                    const { from } = props.location.state || { from: { pathname: "/profile/" + liffId.tele } };
                                    props.history.push(from);
                                }

                            },
                            error => {
                                const { from } = props.location.state || { from: { pathname: "/lineregister" } };
                                props.history.push(from);
                            }
                        );

                }).catch(function (error) {
                    //window.alert('Error getting profile: ' + error);
                });
            }
            else {

            }

        })
        .catch((err) => {

        });
    */
    //const currentUser = authenticationService.currentUserValue;
    //if (!currentUser) {
    //    return <Redirect to={{ pathname: '/login', /*state: { from: props.location }*/ }} />
    //}

    return (
        <>
            <Container>
                <Row>
                    <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: '10px', fontSize: '1.5em', height: '250px', color: 'white', backgroundColor: '#056839', textAlign: 'center', borderRadius: '0 0 10% 10%' }}>
                        ประวัติการรับวัคซีน <br />
                        {FullName} <br />
                        {(CertId != "") ?
                            <a href={"https://co19cert.moph.go.th/moph-immu/#/vaccine/certificate?cid=" + CertId} target="_blank">
                                <img src={"https://co19cert.moph.go.th/moph-backend/api/immunization-stat/qr/" + CertId} width="145" /> <br />
                                <div style={{ fontSize: '0.9rem', color: 'white' }}> QRCode ใบรับรองแบบย่อ จากกระทรวงสาธารณสุข</div>
                            </a>
                            :
                            <></>
                        }
                    </Col>
   
                </Row>
                <Row style={{ padding: '10px', margin: (CertId != "") ? '0' : '-150px 0 0 0' }}>
                    <Col>
                        {
                            (Visit.length == 0) ?
                             <>
                                <Row style={{ marginBottom: '10px' }}>
                                    <Col>  <Input onChange={e => setCid(e.target.value)} style={{ fontSize: '1.2em', background: 'white' }} type="number" name="Cid" id="Cid" placeholder="กรุณาระบุเลขที่บัตรประจำตัวประชาชน" maxLength="13" /> </Col>
                                </Row>
                                <Row style={{textAlign:'center', marginBottom: '10px' }}>
                                    <Col>
                     
                                                <Button color="primary" onClick={handleSearch} >ค้นหา</Button>
                                        
                                    </Col>
                                </Row>
                             </>
                            :
                            <></>
                        }
                        {visitRender}

                        {(IsSearch && Visit.length < 2) ? notfoundRender : <></> }

                        {/*
                        <Row style={{ marginBottom: '10px' }}>
                            <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: '10px', fontSize: '1.5em', height: '50px', backgroundColor: '#f0dc64', textAlign: 'center', borderRadius: '10px 10px 0 0' }}> ชื่อวัคซีน : Covid-19 Vaccine</Col>
                            <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: 0, fontSize: '1.2em', height: '200px', backgroundColor: '#eee', textAlign: 'center', borderRadius: '0 0 10% 10%' }}> 
                                <Row style={{textAlign:'left', padding:'5px'}}>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">ชื่ออ้างอิง : COVILO</Col>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">เข็มที่ : 1</Col>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">วันที่ได้รับ : 18 สิงหาคม 2564</Col>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">Lot No : 1234567890</Col>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">โรงพยาบาล : โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง</Col>
                                </Row>
                            </Col>

                        </Row>
                        <Row style={{ marginBottom: '10px' }}>
                            <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: '10px', fontSize: '1.5em', height: '50px', backgroundColor: '#f0dc64', textAlign: 'center', borderRadius: '10px 10px 0 0' }}> ชื่อวัคซีน : Covid-19 Vaccine</Col>
                            <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: 0, fontSize: '1.2em', height: '200px', backgroundColor: '#eee', textAlign: 'center', borderRadius: '0 0 10% 10%' }}>
                                <Row style={{ textAlign: 'left', padding: '5px' }}>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">ชื่ออ้างอิง : COVILO</Col>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">เข็มที่ : 2</Col>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">วันที่ได้รับ : 13 กันยายน 2564</Col>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">Lot No : 1234567890</Col>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12">โรงพยาบาล : โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง</Col>
                                </Row>
                            </Col>
                        </Row>
                        */}

                    </Col>
                </Row>

           </Container>
        </>
    );
}

export default Vaccine;
